/* unplugin-vue-components disabled */import script from "./PlayGround.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayGround.vue?vue&type=script&setup=true&lang=js"

import "./PlayGround.vue?vue&type=style&index=0&id=53f11e01&lang=less"

const __exports__ = script;

export default __exports__